module.exports = __webpack_public_path__ + "img/HYU-background.9959dc4b.jpg";